import { SortedNeed, collectiveAdvicesChecked } from "../utils";

import { Paragraph } from "App/global-style";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { CollectiveAdvice } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import React from "react";
import { StyledAdviceH3 } from "../../adviceStyled";
import { AdviceIntroMessages } from "../AkaAdviceMessages/AdviceIntroMessages";

interface Props {
  collectiveAdvice: CollectiveAdvice;
  sortedNeeds: SortedNeed[];
}

export const CollectiveAdviceIntro = ({
  collectiveAdvice,
  sortedNeeds,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const numberOfRecommendedAkaAdvices =
    collectiveAdvicesChecked(collectiveAdvice).length;

  return (
    <>
      <Paragraph className="AdviceIntroText" style={{ marginBottom: 8 }}>
        {
          "Vi har analysert svarene dine, og anbefaler en kombinasjon av kollektive A+ forsikringer og individuelle forsikringer for at du skal være godt dekket for en trygg fremtid."
        }
      </Paragraph>
      {!isAdvisor && numberOfRecommendedAkaAdvices < 3 && (
        <Paragraph className="AdviceIntroText">
          {
            "Ta kontakt med vårt kundesenter for anbefalinger om alternativer til forsikringer du ikke kan kjøpe (på internett)."
          }
        </Paragraph>
      )}
      <AdviceIntroMessages sortedNeeds={sortedNeeds} isCollectiveAdvice />
      {numberOfRecommendedAkaAdvices > 0 && (
        <StyledAdviceH3>
          {"Dette er en anbefaling, du kan selv tilpasse forsikringene under."}
        </StyledAdviceH3>
      )}
    </>
  );
};
